/**
 * Lets the open-delivery cards outside collection pages choose which delivery's timeline shows
 * beneath them. Exactly one card is selected at a time; selecting it again keeps it selected, so a
 * timeline is always shown. The toggles stay hidden until this element connects, and without it
 * the first delivery's timeline shows.
 */
class DeliveryCardsTimelines extends HTMLElement {
  connectedCallback() {
    for (const toggle of this.#toggles) {
      toggle.hidden = false;
      toggle.addEventListener('click', this.#onClick);
    }
  }

  disconnectedCallback() {
    for (const toggle of this.#toggles) toggle.removeEventListener('click', this.#onClick);
  }

  /** @param {Event} event */
  #onClick = (event) => {
    const selected = event.currentTarget;
    if (!(selected instanceof HTMLButtonElement)) return;

    for (const toggle of this.#toggles) {
      const isSelected = toggle === selected;
      toggle.setAttribute('aria-pressed', String(isSelected));
      const timeline = document.getElementById(toggle.getAttribute('aria-controls') ?? '');
      if (timeline) timeline.hidden = !isSelected;
    }
  };

  /** @returns {HTMLButtonElement[]} */
  get #toggles() {
    return Array.from(this.querySelectorAll('button[data-timeline-toggle]'));
  }
}

if (!customElements.get('delivery-cards-timelines')) {
  customElements.define('delivery-cards-timelines', DeliveryCardsTimelines);
}
